<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="section-hotels-edit-rooms">
            <div class="hotels-wrap">
              <HotelsSideMenu />
              <div class="hotels-content">
                <div class="lds-ring" v-if="!isLoad">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div class="hotel-inner hotel-inner__camps" v-if="isLoad">
                  <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                  <form class="policy">
                    <h2>Payment Policy</h2>
                    <div class="subtitle">Please choose one of the following deposit options</div>

                    <div class="radio-container">
                      <div class="radio">
                        <input id="STANDARD" value="STANDARD" type="radio" v-model="data.selectedPolicy">
                        <label for="STANDARD" class="radio-label">STANDART PAYMENT PLAN</label>
                        <div class="radio-option__content radio-option__content--row">
                          <span>Deposit</span>
                          <BasicInput :value-modifier="data.policy['STANDARD'].depositType.id === 'PERCENTAGE' ? (val) => val > 100 ? 100 : val : null" type="number" v-model="data.policy['STANDARD'].deposit" style="width: 100px;"/>
                          <ClassicSelect custom-width="80px" :items="[{id: 'USD', name: '$'},{id: 'PERCENTAGE', name: '%'}]"
                                         :selected-item="this.data.policy['STANDARD'].depositType"
                                         @select-item="(v) => this.data.policy['STANDARD'].depositType = v"/>
                          <span>is required</span>
                          <BasicInput type="number" v-model="data.policy['STANDARD'].depositDaysPriorToArrival"
                                      style="width: 100px;"/>
                          <span>days before arrival </span>
                        </div>
                        <div class="radio-option__content radio-option__content--row">
                          <span>The remaining balance should be paid</span>
                          <BasicInput type="number" v-model="data.policy['STANDARD'].remainingBalanceDaysPriorToArrival"
                                      style="width: 100px;"/>
                          <span>days prior to arrival</span>
                        </div>
                      </div>

                      <div class="radio">
                        <input id="IMMEDIATE_DEPOSIT" value="IMMEDIATE_DEPOSIT" type="radio"
                               v-model="data.selectedPolicy">
                        <label for="IMMEDIATE_DEPOSIT" class="radio-label"><span class="highlight">Immediate</span>
                          deposit required after the booking</label>
                        <div class="radio-option__content radio-option__content--row">
                          <span>Deposit</span>
                          <BasicInput type="number"
                                      :value-modifier="data.policy['IMMEDIATE_DEPOSIT'].depositType.id === 'PERCENTAGE' ? (val) => val > 100 ? 100 : val : null"
                                      v-model="data.policy['IMMEDIATE_DEPOSIT'].deposit"
                                      style="width: 100px;"/>
                          <ClassicSelect custom-width="80px" :items="[{id: 'USD', name: '$'},{id: 'PERCENTAGE', name: '%'}]"
                                         :selected-item="this.data.policy['IMMEDIATE_DEPOSIT'].depositType"
                                         @select-item="(v) => this.data.policy['IMMEDIATE_DEPOSIT'].depositType = v"/>
                          <span>is required immediately after the booking </span>
                        </div>
                        <div class="radio-option__content radio-option__content--row">
                          <span>The remaining balance should be paid</span>
                          <BasicInput type="number"
                                      v-model="data.policy['IMMEDIATE_DEPOSIT'].remainingBalanceDaysPriorToArrival"
                                      style="width: 100px;"/>
                          <span>days prior to arrival</span>
                        </div>
                      </div>

                      <div class="radio">
                        <input id="SPECIAL_CONDITIONS_1" value="SPECIAL_CONDITIONS_1" type="radio"
                               v-model="data.selectedPolicy">
                        <label for="SPECIAL_CONDITIONS_1" class="radio-label">SPECIAL CONDITIONS - OPTION 1</label>
                        <div class="radio-option__content radio-option__content--row">
                          <span>Full payment is required</span>
                          <BasicInput type="number"
                                      v-model="data.policy['SPECIAL_CONDITIONS_1'].paymentDaysPriorToArrival"
                                      style="width: 100px;"/>
                          <span>days prior to arrival</span>
                        </div>
                      </div>

                      <div class="radio">
                        <input id="SPECIAL_CONDITIONS_2" value="SPECIAL_CONDITIONS_2" type="radio"
                               v-model="data.selectedPolicy">
                        <label for="SPECIAL_CONDITIONS_2" class="radio-label">SPECIAL CONDITIONS - OPTION 2</label>
                        <div class="radio-option__content">
                          Full payment at the end of the month after check-out
                        </div>
                      </div>

                    </div>

                    <div class="edit-rooms__btn-edit">
                      <button type="button" class="btn btn--green" @click="updatePopup = true">
                        <span>Update</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="modal-wrapper" v-if="updatePopup">
              <div class="modal-backdrop"></div>
              <div class="modal-inner">
                <div class="edit-popup edit-popup--history">
                  <div class="edit-popup__header">
                    <div class="edit-popup__title">
                      Update History
                    </div>
                    <div class="edit-popup__close" @click="updatePopup = false">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </div>
                  </div>
                  <form action="javascript:void(0)" class="edit-popup__inner">
                    <div class="form-control-group"><span
                        class="form-control-label">Hi {{ user ? user.data.firstName : '' }}, <span> what have you updated?</span> </span>
                      <div class="form-control-wrap">
                        <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                      </div>
                      <div class="edit-popup__error-text">
                        <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                      </div>
                    </div>
                    <div class="options-additional__btns">
                      <button type="button" class="btn btn--silver" @click="updatePopup = false">
                        <span>Cancel</span>
                      </button>
                      <button type="submit" class="btn btn--green edit-popup__submit"
                              :disabled="descriptionUpdate.length < 6"
                              @click="updatePolicy">
                        <span>Update</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {
  API,
  getHotelsPaymentPolicy,
  updateHotelsPaymentPolicy,
  updateHotelsCamps,
  getHotelAdvanced
} from '@/utilites/api'

import BasicInput from "@/components/UI/Inputs/BasicInput.vue";
import ClassicSelect from "@/components/UI/ClassicSelect/ClassicSelect.vue";
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
  data() {
    return {
      camps: [],
      isLoad: false,
      updatePopup: false,
      descriptionUpdate: '',
      isEdit: false,
      data: {
        selectedPolicy: null,
        policy: {
          ['STANDARD']: {
            type: 'STANDARD',
            deposit: null,
            depositType: {
              id: null,
              name: null,
            },
            depositDaysPriorToArrival: null,
            remainingBalanceDaysPriorToArrival: null
          },
          ['IMMEDIATE_DEPOSIT']: {
            type: 'IMMEDIATE_DEPOSIT',
            deposit: null,
            depositType: {
              id: null,
              name: null,
            },
            remainingBalanceDaysPriorToArrival: null
          },
          ['SPECIAL_CONDITIONS_1']: {
            type: 'SPECIAL_CONDITIONS_1',
            paymentDaysPriorToArrival: null
          },
          ['SPECIAL_CONDITIONS_2']: {
            type: 'SPECIAL_CONDITIONS_2'
          },
        }
      },
      hotelName: ''
    }
  },
  components: {HotelsSideMenu, ClassicSelect, BasicInput},
  props: ['user'],
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  created() {
    getHotelAdvanced(this.$route.params.id)
        .then(res => {
          this.hotelName = res.names.EN
        })
  },
  methods: {
    updatePolicy() {
        updateHotelsPaymentPolicy({
          "policy": this.getPolicyDataByType(this.data.selectedPolicy),
          history: {
            hotelId: +this.$route.params.id,
            userId: this.user.data.id,
            description: this.descriptionUpdate
          }
        }, this.$route.params.id)
            .then(res => {
              this.isEdit = false
              this.$emit('confirmed')
              this.descriptionUpdate = ''
              this.updatePopup = false
            })
    },
    getPolicyDataByType(type) {
      switch (type) {
        case "STANDARD":
          return {
            type: type,
            deposit: this.data.policy[type].deposit,
            depositType: this.data.policy[type].depositType.id,
            depositDaysPriorToArrival: this.data.policy[type].depositDaysPriorToArrival,
            remainingBalanceDaysPriorToArrival: this.data.policy[type].remainingBalanceDaysPriorToArrival
          }
        case "IMMEDIATE_DEPOSIT":
          return {
            type: type,
            deposit: this.data.policy[type].deposit,
            depositType: this.data.policy[type].depositType.id,
            remainingBalanceDaysPriorToArrival: this.data.policy[type].remainingBalanceDaysPriorToArrival
          }
        case "SPECIAL_CONDITIONS_1":
          return {
            type: type,
            paymentDaysPriorToArrival: +this.data.policy[type].paymentDaysPriorToArrival
          }
        case "SPECIAL_CONDITIONS_2":
          return {
            type: type
          }
      }
    },
    fillPolicyDataByType(type, data) {
      switch (type) {
        case "STANDARD":
          this.data.policy[type].type = data.type;
          this.data.policy[type].deposit = data.deposit;
          this.data.policy[type].depositType = {id: data.depositType, name: this.getDepositTypeNameById(data.depositType)}
          this.data.policy[type].depositDaysPriorToArrival = data.depositDaysPriorToArrival;
          this.data.policy[type].remainingBalanceDaysPriorToArrival = data.remainingBalanceDaysPriorToArrival;
          break;
        case "IMMEDIATE_DEPOSIT":
          this.data.policy[type].type = data.type;
          this.data.policy[type].deposit = data.deposit;
          this.data.policy[type].depositType = {id: data.depositType, name: this.getDepositTypeNameById(data.depositType)}
          this.data.policy[type].remainingBalanceDaysPriorToArrival = data.remainingBalanceDaysPriorToArrival;
          break;
        case "SPECIAL_CONDITIONS_1":
          this.data.policy[type].type = data.type;
          this.data.policy[type].paymentDaysPriorToArrival = data.paymentDaysPriorToArrival;
          break;
        case "SPECIAL_CONDITIONS_2":
          this.data.policy[type].type = data.type;
          break;
      }
    },
    getDepositTypeNameById(id) {
      if (id === 'USD') {
        return '$'
      } else {
        return '%'
      }
    },
    waitSaveTiming() {
      const saveFun = () => {
        this.updatePopup = true;
      }
      const waitFun = () => {
        this.waitSaveTiming();
      }
      setTimeout(() => {
        this.$emit('waitSaveHandler', [saveFun, waitFun]);
      }, 10 * 60 * 1000)
    },
  },
  mounted() {
    const id = this.$route.params.id
    Promise.all([getHotelsPaymentPolicy(id)])
        .then(res => {
          this.data.selectedPolicy = res[0].policy === null ? null : res[0].policy.type;
          if (res[0].policy !== null) {
            this.fillPolicyDataByType(res[0].policy.type, res[0].policy);
          }
          this.isLoad = true
        })
  },
  watch: {
    isEdit(val) {
      if (val) this.waitSaveTiming();
    },
  },
}
</script>
<style lang="scss" scoped>
$color1: #f4f4f4;
$color2: #77B017;

.policy {

}

.subtitle {
  font-size: 12px;
  margin-top: 25px;
}

.highlight {
  color: #D80027;
}

.radio {
  padding: 30px 0;
  border-top: 1px solid #DADADA;

  &:first-child {
    margin-top: 20px;
  }

  input[type="radio"] {
    position: absolute;
    opacity: 0;

    + .radio-label {
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      text-transform: uppercase;

      ~ .radio-option__content {
        opacity: .4;
      }

      &:before {
        content: '';
        background: $color1;
        border-radius: 100%;
        border: 1px solid #D3D3D3;
        display: inline-block;
        width: 16px;
        height: 16px;
        position: relative;
        top: -0.2em;
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }

    &:checked {
      + .radio-label {

        ~ .radio-option__content {
          opacity: 1;
        }

        &:before {
          background-color: $color1;
          box-shadow: inset 0 0 0 5px $color2;
        }
      }
    }

    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }

    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }

    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}

.radio-option {
  &__content {
    padding: 10px 0;
    font-size: 12px;
    color: #2E2E2E;

    &--row {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
}

</style>